export const API = "https://api2.cooeprouasd.net/api/"